module.exports = __webpack_public_path__ + "img/video.1aa4f65f.jpg";